export default __webpack_public_path__ + "7990e5187e35346a1a4187485f3d9079.woff";